import { render, staticRenderFns } from "./CommentReply.vue?vue&type=template&id=4e5761eb&scoped=true&lang=pug"
import script from "./CommentReply.vue?vue&type=script&lang=js"
export * from "./CommentReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5761eb",
  null
  
)

export default component.exports